const APP_SHELL_HEADER_SELECTOR = '[data-cname="Header"].appHeader'
const CSS_VAR_NAME = '--app-shell-header-height'

const updateHeaderHeight = (headerEl: Element) => {
    const height = Math.round(headerEl.getBoundingClientRect().height)
    if (height > 0) {
        document.documentElement.style.setProperty(CSS_VAR_NAME, `${height + 8}px`)
    }
}

export const initAppShellHeaderHeight = (): (() => void) => {
    if (typeof window === 'undefined') {
        return () => {}
    }

    let resizeObserver: ResizeObserver | null = null
    let observedHeader: Element | null = null

    const observeHeader = (headerEl: Element) => {
        if (observedHeader === headerEl) {
            return
        }

        resizeObserver?.disconnect()
        observedHeader = headerEl
        updateHeaderHeight(headerEl)

        resizeObserver = new ResizeObserver(() => updateHeaderHeight(headerEl))
        resizeObserver.observe(headerEl)
    }

    const findAndObserve = () => {
        const headerEl = document.querySelector(APP_SHELL_HEADER_SELECTOR)
        if (headerEl) {
            observeHeader(headerEl)
        }
    }

    findAndObserve()

    const mutationObserver = new MutationObserver(findAndObserve)
    mutationObserver.observe(document.body, { childList: true, subtree: true })

    return () => {
        resizeObserver?.disconnect()
        mutationObserver.disconnect()
        document.documentElement.style.removeProperty(CSS_VAR_NAME)
    }
}
